export class Published {
    public published_id: number;
    public hash: string;
    public scenario_id: number;
    public user_id: number;
    public version: string;
    public title: string;
    public config: string;
    public player_version:string;
    public status:string;
    public created: string;
    public modified: string;

  constructor(
    published_id: number,
    hash: string,
    scenario_id: number,
    user_id: number,
    version: string,
    title: string,
    config: string,
    player_version:string,
    status:string,
    created: string,
    modified: string,
  ) {
    this.published_id = published_id;
    this.hash = hash;
    this.scenario_id = scenario_id;
    this.user_id = user_id;
    this.version = version;
    this.title = title;
    this.config = config;
    this.player_version = player_version;
    this.status = status;
    this.created = created;
    this.modified = modified;
  }
}
